module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/instagram_big-ee109ac6be2092ae9a8386e1768b3f56.svg";